module.exports = __webpack_public_path__ + "static/media/rebates_bg.97b67b2b.webp";